// Production
// export const IP = "54.169.139.29";
export const IP = "isdbi.koncepts.co";
export const localurl = `https://${IP}/api`;



// STAGGING
// export const IP = "13.229.184.79";
// export const localurl = `http://${IP}/api`;

// local
// export const IP = "127.0.0.1:8000";
// export const localurl = `http://${IP}/api`;

